import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      position: relative;\n      justify-content: center;\n\n      .capacity-label {\n        position: absolute;\n        margin: 0;\n        text-align: center;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n\n  .capacity-label {\n    font-size: 0.75rem;\n    margin-right: 0.25rem;\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Text } from '../index';
var StyledCapacity = styled.div(_templateObject(), function (props) {
  return props.labelInside && css(_templateObject2());
});

function getStokeColor(capacity) {
  if (capacity === 100) {
    return '#ff754c';
  }

  if (capacity >= 80) {
    return '#ffce73';
  }

  return '#7fba7a';
}

function getSize(size) {
  if (size === 'large') {
    return {
      stroke: 4,
      radius: 24
    };
  }

  return {
    stroke: 4,
    radius: 14
  };
}

function Capacity(_ref) {
  var children = _ref.children,
      capacity = _ref.capacity,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;

  var _capacity = capacity > 100 ? 100 : capacity;

  var _getSize = getSize(size),
      radius = _getSize.radius,
      stroke = _getSize.stroke;

  var normalizedRadius = radius - stroke;
  var circumference = normalizedRadius * 2 * Math.PI;
  var strokeDashoffset = circumference - _capacity / 100 * circumference;
  return _jsxs(StyledCapacity, Object.assign({
    labelInside: size === 'large',
    className: "capacity"
  }, {
    children: [children && _jsx(Text, Object.assign({
      className: "capacity-label",
      small: true,
      appearance: size === 'large' ? 'default' : 'faded'
    }, {
      children: children
    }), void 0), _jsxs("svg", Object.assign({
      className: "capacity-ring",
      height: radius * 2,
      width: radius * 2,
      style: {
        transform: 'rotate(-90deg)'
      }
    }, {
      children: [_jsx("circle", {
        stroke: "#eeeeee",
        fill: "transparent",
        strokeWidth: stroke,
        r: normalizedRadius,
        cx: radius,
        cy: radius
      }, void 0), _jsx("circle", {
        stroke: getStokeColor(_capacity),
        strokeLinecap: "round",
        fill: "transparent",
        strokeWidth: stroke,
        strokeDasharray: circumference + ' ' + circumference,
        style: {
          strokeDashoffset: strokeDashoffset
        },
        r: normalizedRadius,
        cx: radius,
        cy: radius
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default Capacity;